"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import { AudienceBuilder } from "./components/AudienceBuilder";
import { AudienceCriteria } from "./types/audienceTypes";

/**
 * Standalone page for the Email Audience Builder
 * Accessible at /email-management/audience/new
 */
export function EmailAudienceBuilderPage() {
  const navigate = useNavigate();

  const handleSave = (criteria: AudienceCriteria, name: string) => {
    // TODO: Save audience via API
    console.log("Saving audience:", { name, criteria });

    // Navigate back to campaign creation or audience list
    navigate("/email-management/email-campaigns");
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <AudienceBuilder
      onCancel={handleCancel}
      onSave={handleSave}
    />
  );
}

export default EmailAudienceBuilderPage;
